export default "__VITE_ASSET__PmB2Iro$__"